import { logStartUsage } from 'owa-analytics-start';
import { tryGetGlobalSettingsAccountMailboxInfo } from 'owa-account-source-list-store';
let logCallbacks: (() => string)[] = [];

export const registerGetLogCallback = (callback: () => string): void => {
    // Registering the same callback twice would run every collection twice, opening two ODS
    // sessions and sending two feedback emails from a single host request.
    if (logCallbacks.indexOf(callback) !== -1) {
        return;
    }
    logCallbacks.push(callback);
};

export const unRegisterGetLogCallback = (callback: () => string): void => {
    logCallbacks = logCallbacks.filter(cb => cb !== callback);
};

export function executeGetLogs(): string {
    logStartUsage('MetaOsAppExecuteGetLogs', tryGetGlobalSettingsAccountMailboxInfo());
    const logs = logCallbacks.map(callback => callback()).join('\n');
    return 'Callback count: ' + logCallbacks.length + '\nCollected logs:\n' + logs;
}
